import { IPromise, IHttpService } from "angular";
import { IAccountRolesResponse, IRole } from "./models";
import { IUser } from "../users/models";
import { EnvironmentService } from "@gtmhub/env";
import { IDynamicSubteamsRole } from ".";

export class RoleService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getRoles(options: { includeTeamRoles?: boolean } = {}): IPromise<IAccountRolesResponse> {
    const query = options.includeTeamRoles != null ? "?includeTeamRoles=" + options.includeTeamRoles : "";
    const url = this.env.getApiEndpoint("/roles" + query);

    return this.$http.get<IAccountRolesResponse>(url).then((response) => {
      const roles = response.data;
      // remove the SysAdmin role, as this is not to be shown
      // on the client web app
      for (let i = 0; i < roles.items.length; i++) {
        if (roles.items[i].name === "SysAdmin") {
          roles.items.splice(i, 1);

          break;
        }
      }
      return roles;
    });
  }

  public deleteRole(id: string): IPromise<null> {
    const url = this.env.getApiEndpoint("/roles/account/" + id);

    return this.$http.delete(url).then(() => null);
  }

  public getRole(id: string): IPromise<IRole | IDynamicSubteamsRole> {
    const url = this.env.getApiEndpoint("/roles/" + id);

    return this.$http.get<IRole>(url).then((response) => response.data);
  }

  public createRole(role: IRole): IPromise<IRole> {
    const url = this.env.getApiEndpoint("/roles/account");

    return this.$http.post<IRole>(url, role).then((response) => response.data);
  }

  public addUserToRole(role: IRole, user: IUser): IPromise<void> {
    const url = this.env.getApiEndpoint("/users/" + user.id + "/roles");

    return this.$http.post<void>(url, { roleId: role.id }).then(() => null);
  }

  public removeUserFromRole(role: IRole, user: IUser): IPromise<void> {
    const url = this.env.getApiEndpoint("/users/" + user.id + "/roles/" + role.id);

    return this.$http.delete<void>(url).then(() => null);
  }

  public removeUserFromRoles(roles: IRole[], user: IUser): IPromise<void> {
    const roleIds = roles.map((role) => role.id).join(",");
    const url = this.env.getApiEndpoint(`/users/${user.id}/roles?ids=${encodeURIComponent(roleIds)}`);

    return this.$http.delete<void>(url).then(() => null);
  }

  public updateRole(role: IRole): IPromise<IRole> {
    const url = this.env.getApiEndpoint("/roles/account/" + role.id);

    return this.$http.put<IRole>(url, role).then((response) => response.data);
  }
}
